export const IP_GEOLOCATION_LOAD_START = 'IP_GEOLOCATION_LOAD_START';
export const IP_GEOLOCATION_LOAD_SUCCESS = 'IP_GEOLOCATION_LOAD_SUCCESS';
export const IP_GEOLOCATION_LOAD_ERROR = 'IP_GEOLOCATION_LOAD_ERROR';
